module.exports = __webpack_public_path__ + "media/src/images/abouts/cards/goodjob/1912_otsukaresama-fd3a1bbd71472b5ea9935ff829b6cd5b.jpg";